import * as actions from "../actions";
import React, { Component } from 'react'

import loadImage from 'blueimp-load-image'

class FileUploadButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileInputValue: props.fileInputValue || '',
      disabled: props.disabled || false
    };

    this.handleFileInputChange = this.handleFileInputChange.bind(this);
  }

  render() {
    const buttonClass = this.props.buttonClass || '';

    if('isUploading' in this.props){
      this.state.isUploading = this.props.isUploading;
    }

    if('disabled' in this.props){
      this.state.disabled = this.props.disabled;
    }

    const { fileInputValue, disabled } = this.state;
    const { stagedFiles } = this.props;
    const isStaging = stagedFiles.count > 0;

    return (
      <div className='file-upload-button-view'>
        <button
          disabled={disabled}
          type="button"
          className={`${buttonClass} add-photos`}
        >
          <i className="icon-camera"/>
          {!isStaging? 'Add Photos': 'Add More Photos'}
        </button>
        <input
          disabled={disabled}
          name="photo"
          ref="uploadButton"
          type="file"
          value={fileInputValue}
          onChange={this.handleFileInputChange}
          accept='image/*'
          multiple
        />
      </div>
    );
  }

  handleFileInputChange(event) {
    event.preventDefault();
    const files = event.target.files;
    this.setState({ fileInputValue: '', isUploading: true });

    this.updateStateWithFiles(files).then(() => {
      this.setState({isUploading: false});
    });

    return false;
  }

  updateStateWithFiles(files) {
    let numFilesToAdd;

    let { stagedFiles, maxFiles } = this.props;
    if (stagedFiles.count + files.length <= maxFiles) {
      numFilesToAdd = files.length;
    } else {
      let availableSpaces = (maxFiles - stagedFiles.count);
      numFilesToAdd = Math.min(files.length, availableSpaces);
    }

    const stageFilePromises = [];
    for(let i = 0; i < numFilesToAdd; i++) {
      const file = files[i];
      actions.addFileToStage('');

      if (file.type === 'image/gif') {
        stageFilePromises.push(stageFile(file));
      } else {
        stageFilePromises.push(resizeAndStageFile(file));
      }
    }

    return Promise.all(stageFilePromises);
  }
}

function resizeAndStageFile(file) {
  return new Promise(function (resolve, reject) {
    // Use the loadImage lib to resize a jpg and preserve any exif orientation
    loadImage.parseMetaData(file, function (data) {
      const orientation = data.exif? data.exif.get('Orientation'): 1;
      loadImage(file, function (canvas) {
        if (canvas.type === "error") {
          reject('Canvas error');
        } else {
          resolve(canvas.toDataURL('image/jpeg'))
        }
      }, {
        maxWidth: 1600,
        maxHeight: 1600,
        canvas: true,
        orientation
      });
    });
  })
    .then((url) => {
      actions.removeFileFromStage('');
      actions.addFileToStage(url);
    })
    .catch((reason) => {
      if (console && console.error) {
        console.error(reason);
      }
    });
}

function stageFile(file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  })
    .then((url) => {
      actions.removeFileFromStage('');
      actions.addFileToStage(url);
    })
    .catch((reason) => {
      if (console && console.error) {
        console.error(reason);
      }
    });
}

export default FileUploadButton;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/file-uploader/components/file-upload-button.es6